import axios from 'axios';
import router from '@/router'
// import {Message} from 'element-ui'
import { storageData } from '@/assets/js/storage';
import { WindowsToaster } from 'node-notifier';
import {Message} from 'element-ui'
const service = axios.create({
  timeout: 50000,
});
/* 请求拦截器 */
service.interceptors.request.use(
  (config) => {
    /* 取token */
    const token = storageData.getToken();
    if (token) {
      if(config.method=='post') {
        config.data = {
          ...config.data,
          token: token
        }
      }
      // config.headers['token'] = token;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

/* 响应拦截器 */
service.interceptors.response.use(
  (res) => {
    // console.log(router.currentRoute)
    // console.log(router.currentRoute.fullPath)
    // 未登录
    if(res.data.code=='420' || res.data.code=='422') {
      router.replace({
        path:`/arealogin?redirect=${router.currentRoute.fullPath}`,
      })
    }
    if(res.data.code =='403'){
      Message(res.data.message) 
    }
    return res;
  },
  (err) => {
    console.error('响应发生了错误', err);
    return Promise.reject(err);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/api/service/service.js